import React from "react";

export function Info() {
  return (
    <>
      <div className="bg-remark p-4 rounded border border-label overflow-hidden">
        <h3 className="lg:text-xl font-bold mb-4">預購流程</h3>
        <h4 className="lg:text-lg font-bold mb-4">【產品規格】</h4>
        <ol className="list-decimal list-inside">
          <li className="mb-4">口罩尺寸為 17.5cm x 9.5cm</li>
          <li className="mb-4">
            細菌過濾率（BFE）、粒子過濾率（PFE）及病毒過濾率（VFE）達到95%或以上
          </li>
          <li className="mb-4">於PrimeHK無塵及無菌工廠完成生產及包裝工序</li>
          <li className="mb-4">嚴格監管原材料、機械設備、生產環境及口罩品質</li>
          <li className="mb-4">葵涌自設廠房，真正香港製造</li>
        </ol>
        <h4 className="lg:text-lg font-bold mb-4">【領籌方式】</h4>
        <ol className="list-inside">
          <li className="mb-4">1. 於 PrimeHK 公佈時間進入領籌網址。</li>
          <li className="mb-4">2. 輸入電郵登記，及選擇想訂購的套裝。</li>
          <li className="mb-4">
            3.
            所有填寫的資料必須正確，如有任何錯誤、遺漏或無法辨識所輸入資料等情況，您的登記將有機會自動作廢。
          </li>
          <li className="mb-4">4. 耐心等待結果。</li>
          <li className="mb-4">
            5a. 若能成功領籌，會轉到成功領籌頁面，成功獲得籌號。
          </li>
          <li className="mb-4">
            5b. 若未能成功領籌（派完所有籌），會轉到未能成功頁面。
          </li>
        </ol>
        <h4 className="lg:text-lg font-bold mb-4">【購買方式】</h4>
        <ol className="list-decimal list-inside">
          <li className="mb-4">
            成功領籌後，我們將會以電郵發放專屬您的購買連結及購買碼。該購買碼只能使用一次，購買您所選擇的套裝。
          </li>
          <li className="mb-4">
            電郵將於登記後隨即陸續發送，預計將於活動開始後
            10小時內發送所有電郵。
          </li>
          <li className="mb-4">
            已收到電郵的顧客，可進入電郵内提供的購買連結，並需於當天23:59前完成購買和結帳。
          </li>

          <li className="mb-4">
            在購買連結内的頁面選取商品後，輸入姓名，電話，電郵，揀選取貨地點，選取付款方法（包括Visa,
            Mastercard, Apple Pay, Google
            Pay），及輸入購買碼。完成付款后，會轉到成功購買頁面，顯示獨特的訂單編號。與此同時，亦會收到系統發出的確認訂單（内有訂單編號）的電郵。
          </li>

          <li className="mb-4">
            結帳時不用心急，可慢慢填上所需資料及選擇取貨地點。填寫的資料必須正確，一經付款，我們將無法為閣下修改或取消訂單。{" "}
          </li>

          <li className="mb-4">
            在發貨之前，閣下會再收到取貨電郵，通知編配的時段及你選取的取貨地點安排領取商品。在領取貨品時，請向職員出示相關的電郵。{" "}
          </li>
        </ol>
        <h3 className="lg:text-xl font-bold mb-4">條款及細則</h3>
        <ol className="list-decimal list-inside">
          <li className="mb-4">一經付款，我們將無法為閣下修改或取消訂單； </li>
          <li className="mb-4">
            閣下所提供的資料只會用作購買相關商品之用，不會做任何其他用途，亦不會把資料傳送給主辦單位或服務供應商外的任何第三方，資料亦會在商品派送完畢後三個月内銷毀；
          </li>
          <li className="mb-4">如有任何爭議，PrimeHK 將保留最終決定權。 </li>
        </ol>
        <p>
          如有任何貨品查詢，歡迎電郵至我們的客戶服務{" "}
          <a className="hover:underline" href="mailto:cs@theprimehk.com">
            cs@theprimehk.com
          </a>
          。
        </p>
      </div>
    </>
  );
}
